import script from "./contentMobile.vue?vue&type=script&setup=true&lang=js"
export * from "./contentMobile.vue?vue&type=script&setup=true&lang=js"

import "./contentMobile.vue?vue&type=style&index=0&id=bf120ac6&scoped=true&lang=less"
import "./contentMobile.vue?vue&type=style&index=1&id=bf120ac6&lang=css"

import exportComponent from "/workspace/office-website/company-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf120ac6"]])

export default __exports__